/* eslint-disable import/no-unresolved */
import { Helmet } from 'react-helmet-async';
import heroImage from '../../images/best-car-inspection-service-kerala-hero.jpg';

export default function BestCarInspectionServicePage() {
  const faqSchema = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: [
      {
        '@type': 'Question',
        name: 'Why is Focus Motors considered one of the best car inspection services in Kerala?',
        acceptedAnswer: {
          '@type': 'Answer',
          text: 'Focus Motors has completed 150+ inspections since 2023, offering same-day reports, 130+ check points, and on-site inspection across Kerala, backed by strong customer reviews.',
        },
      },
      {
        '@type': 'Question',
        name: 'How quickly do I get the inspection report?',
        acceptedAnswer: {
          '@type': 'Answer',
          text: 'We provide a same-day report after the inspection is completed, so you can make a quick, informed decision.',
        },
      },
      {
        '@type': 'Question',
        name: 'How many points do you check during inspection?',
        acceptedAnswer: {
          '@type': 'Answer',
          text: 'Our inspection covers 130+ check points, including engine, transmission, brakes, electricals, body condition, and documentation.',
        },
      },
      {
        '@type': 'Question',
        name: 'Do you have customer reviews?',
        acceptedAnswer: {
          '@type': 'Answer',
          text: 'Yes, we have multiple 5-star customer reviews on Google, with customers highlighting our professionalism, detailed reporting, and honest assessments.',
        },
      },
    ],
  };

  const serviceSchema = {
    '@context': 'https://schema.org',
    '@type': 'Service',
    serviceType: 'Car Inspection Service',
    provider: { '@type': 'Organization', name: 'Focus Motors', url: 'https://focusmotors.in' },
    areaServed: { '@type': 'State', name: 'Kerala' },
    url: 'https://focusmotors.in/best-car-inspection-service-kerala',
    description:
      'Trusted car inspection service in Kerala since 2023, with 150+ inspections completed, same-day reports, and 130+ check points.',
    aggregateRating: {
      '@type': 'AggregateRating',
      ratingValue: '5.0',
      reviewCount: '3',
    },
  };

  return (
    <>
      <Helmet>
        <title>Best Car Inspection Service in Kerala | Focus Motors</title>
        <meta
          name="description"
          content="Trusted car inspection service in Kerala since 2023. 150+ inspections completed, same-day reports, 130+ check points. Read our customer reviews."
        />
        <meta
          name="keywords"
          content="best car inspection service Kerala, trusted car inspection Kerala, car inspection reviews Kerala"
        />
        <link rel="canonical" href="https://focusmotors.in/best-car-inspection-service-kerala" />
        <meta property="og:title" content="Best Car Inspection Service in Kerala | Focus Motors" />
        <meta
          property="og:description"
          content="Trusted car inspection service since 2023 — 150+ inspections, same-day reports, 130+ check points."
        />
        <meta property="og:url" content="https://focusmotors.in/best-car-inspection-service-kerala" />
        <script type="application/ld+json">{JSON.stringify(faqSchema)}</script>
        <script type="application/ld+json">{JSON.stringify(serviceSchema)}</script>
      </Helmet>

      <div
        style={{ maxWidth: '900px', margin: '0 auto', padding: '40px 20px', fontFamily: 'inherit', color: '#ffffff' }}
      >
        <img
          src={heroImage}
          alt="Best car inspection service in Kerala"
          style={{
            width: '100%',
            height: 'auto',
            maxHeight: '450px',
            objectFit: 'cover',
            borderRadius: '12px',
            marginBottom: '30px',
          }}
        />

        <h1>Best Car Inspection Service in Kerala</h1>
        <p>
          Focus Motors has been helping car buyers across Kerala make confident decisions since 2023 — with 150+
          inspections completed, same-day reports, and a thorough 130+ point check on every car.
        </p>

        <h2>Why We're Trusted</h2>
        <ul>
          <li>
            <strong>150+ inspections completed</strong> since 2023
          </li>
          <li>
            <strong>Same-day report</strong> — get results quickly, make faster decisions
          </li>
          <li>
            <strong>130+ check points</strong> — engine, transmission, brakes, electricals, body, and documentation
          </li>
          <li>
            <strong>On-site inspection</strong> — our inspector comes to the car's location, anywhere in Kerala
          </li>
        </ul>

        <h2>What Our Customers Say</h2>

        <div
          style={{ marginBottom: '16px', padding: '20px', background: 'rgba(255,255,255,0.05)', borderRadius: '8px' }}
        >
          <p style={{ fontStyle: 'italic' }}>
            "Outstanding experience with Focus Inspections during the pre-purchase inspection of my pre-owned BMW 5
            Series. The inspection gave me complete confidence to proceed with the purchase."
          </p>
          <p style={{ marginBottom: 0 }}>
            <strong>— Jithin Joseph</strong>, Google Review
          </p>
        </div>

        <div
          style={{ marginBottom: '16px', padding: '20px', background: 'rgba(255,255,255,0.05)', borderRadius: '8px' }}
        >
          <p style={{ fontStyle: 'italic' }}>
            "Based on their detailed inspection report, I was able to negotiate with the used car showroom and
            successfully reduce the price before purchasing the car."
          </p>
          <p style={{ marginBottom: 0 }}>
            <strong>— Chikku</strong>, Google Review
          </p>
        </div>

        <div
          style={{ marginBottom: '20px', padding: '20px', background: 'rgba(255,255,255,0.05)', borderRadius: '8px' }}
        >
          <p style={{ fontStyle: 'italic' }}>"Great guidance and support."</p>
          <p style={{ marginBottom: 0 }}>
            <strong>— Sachin Dev</strong>, Google Review
          </p>
        </div>

        <a
          href="https://focusmotors.in/inspection-booking"
          style={{
            display: 'inline-block',
            marginTop: '10px',
            padding: '12px 24px',
            background: '#000',
            color: '#fff',
            textDecoration: 'none',
            borderRadius: '6px',
          }}
        >
          Book an Inspection
        </a>

        <h2>Available Across Kerala</h2>
        <p>
          Our inspection service covers all of Kerala — Kochi, Thrissur, Kozhikode, Malappuram, Thiruvananthapuram, and
          more.
        </p>

        <h2>Frequently Asked Questions</h2>

        <h3>Why is Focus Motors considered one of the best car inspection services in Kerala?</h3>
        <p>150+ inspections since 2023, same-day reports, 130+ check points, and strong customer reviews.</p>

        <h3>How quickly do I get the inspection report?</h3>
        <p>We provide a same-day report after the inspection is completed.</p>

        <h3>How many points do you check during inspection?</h3>
        <p>
          Our inspection covers 130+ check points, including engine, transmission, brakes, electricals, body, and
          documentation.
        </p>

        <h3>Do you have customer reviews?</h3>
        <p>Yes, we have multiple 5-star customer reviews on Google.</p>
      </div>
    </>
  );
}
